const getDashboardSelectProps = (setMenuOpen = () => {}) => ({
  className: "dashboard-filter-select",
  classNamePrefix: "elmis-select",
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
  menuPlacement: "auto",
  menuShouldScrollIntoView: true,
  closeMenuOnScroll: true,
  maxMenuHeight: 220,
  onMenuOpen: () => setMenuOpen(true),
  onMenuClose: () => setMenuOpen(false),
  styles: {
    control: base => ({
      ...base,
      minHeight: 38,
    }),
    menuPortal: base => ({
      ...base,
      zIndex: 99999,
    }),
    menu: base => ({
      ...base,
      zIndex: 99999,
      marginTop: 4,
      marginBottom: 4,
    }),
    option: base => ({
      ...base,
      cursor: "pointer",
    }),
  },
})

export default getDashboardSelectProps
